import { clamp } from "lodash-es";
import type { DefaultValues } from "react-hook-form";
import { REFINANCING_LIMITS } from "shared/CalculatorLimits";
import {
	REFINANCING_DEFAULT_PAID_YEARS,
	REFINANCING_DEFAULT_YEARS,
} from "web_myplann/Calculators/constants";
import type { RefinancingFormModel } from "web_myplann/Calculators/Types/RefinancingFormModel";
import { getMaxPaidYears } from "web_myplann/Calculators/Utils/getMaxPaidYears";
import type { CalculatorPrefill } from "web_myplann/Utils/WebViewModel";

export const mapRefinancingPrefillToForm = (
	prefill?: CalculatorPrefill | null,
): DefaultValues<RefinancingFormModel> => {
	const years = clamp(
		prefill?.originMortgageYears ?? REFINANCING_DEFAULT_YEARS,
		REFINANCING_LIMITS.yearsMin,
		REFINANCING_LIMITS.yearsMax,
	);

	return {
		propertyPrice: undefined,
		monthlyPayment:
			prefill?.originMonthlyPayment === undefined
				? undefined
				: Math.min(
						prefill.originMonthlyPayment,
						REFINANCING_LIMITS.monthlyPaymentMax,
					),
		interest:
			prefill?.originInterest === undefined
				? undefined
				: Math.min(prefill.originInterest, REFINANCING_LIMITS.interestMax),
		years,
		paidYears: clamp(
			prefill?.repaymentPeriod ?? REFINANCING_DEFAULT_PAID_YEARS,
			REFINANCING_LIMITS.paidPeriodMin,
			getMaxPaidYears(years),
		),
	};
};
